module.exports = __webpack_public_path__ + "favicon/mstile-150x150.png";